<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          :api-getlist='getRequestList'
          :subtitle="protocol.name"
          :config="config"
          :filters="{ protocol_id }"
          hide-upsert>
          <template slot='headerActions'>
            <v-btn
              color="pink"
              @click="newRequest">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_list.js'
import { getRequestList } from '@/api/request'
const { getDetail } = require('@/api/base_entity')

export default {
  data () {
    return {
      config,
      getRequestList,
      protocol_id: Number(this.$route.params.protocolId),
      protocol: {}
    }
  },
  async created () {
    if (this.$route.params.protocolId) {
      this.protocol = await getDetail('protocol', { id: this.protocol_id })
    }
  },
  methods: {
    newRequest () {
      this.$router.push(`/protocol/${this.protocol.id}/request/new`)
    }
  }
}
</script>
